module.exports = __webpack_public_path__ + "static/cnn_bg-e99210d3003c5249fc3f73072fddfb88.png";